module.exports = __webpack_public_path__ + "img/font_yue@2x.e4d4ac78.png";